import { create } from 'zustand';
import { IFeedback } from '../../../core/models/essay';

interface IFeedbackState {
  feedback: IFeedback | null;
  setFeedback: (feedback: IFeedback) => void;
}

export const useFeedbackStore = create<IFeedbackState>((set) => ({
  feedback: null,
  setFeedback: (feedback: IFeedback) => set({ feedback })
}));
